import { ReactNode } from "react";

/** Shared detail header code + badge slot (Offers / Tasks / Requests). */
export function SideBarEntityTitle({ code, children }: { code: string; children: ReactNode }) {
  return (
    <>
      <h2 className="text-color-primary h-full min-w-0 text-3xl font-medium">
        <button type="button" className="max-w-full cursor-pointer truncate text-left outline-0" title={code}>
          {code}
        </button>
      </h2>
      {children}
    </>
  );
}
